module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Notes on Translation")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have used both English and Chinese sources for this study. I translated all the Chinese sources used in this study when the English translations were not available or were inaccurate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mao wrote many speeches and essays in different time periods, but the English versions of his selected works were published in later years. In each citation to Mao’s speeches, I give two dates: the year of Mao’s work and the year in which the English translation was published. For example, I use “Mao 1937/1967” to indicate that the speech was written in 1937 and the translation was published in 1967.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-107eec94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Fm03.vue
// module id = 87
// module chunks = 0